import { render, staticRenderFns } from "./his-zhuyuan.vue?vue&type=template&id=52ddaae4&scoped=true&"
import script from "./his-zhuyuan.vue?vue&type=script&lang=ts&"
export * from "./his-zhuyuan.vue?vue&type=script&lang=ts&"
import style0 from "./his-zhuyuan.vue?vue&type=style&index=0&id=52ddaae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ddaae4",
  null
  
)

export default component.exports